import { contextFactory } from '../../hooks';
import { MultiStepControl } from './multi-step.hooks';

export const [MultiStepContext, useMultiStepContext] = contextFactory<MultiStepControl>();
